import TopMenu from './TopMenu';
import HomeSection from './HomeSection';
import TrustedSection from './TrustedSection';
import TransitionSection from './TransitionSection';
import TransitionSectionOne from './TransitionSectionOne';
import StatsSection from './StatsSection';
import FutureSection from './FutureSection';
import ComparisonSection from './ComparisonSection';
import ResumeSkillSection from './ResumeSkillSection';
import HiringToolsSection from './HiringToolsSection';
import CoursesSection from './CoursesSection';
import SkillsTabs from './SkillsTabs';
import FaqSection from './FaqSection';
import Footer from './Footer';
import ScrollToTop from './ScrollToTop';

const LandingPage = ({ theme, toggleTheme }) => {
  return (
    <div className={`app-root theme-${theme}`}>
      <TopMenu theme={theme} toggleTheme={toggleTheme} />
      <HomeSection theme={theme} />
      <TrustedSection theme={theme} />
      <TransitionSection theme={theme} />
      <StatsSection theme={theme} />
      <TransitionSectionOne theme={theme} />
      <FutureSection theme={theme} />
      <div className="section-gradient-transition"></div>
      <ComparisonSection theme={theme} />
      <ResumeSkillSection theme={theme} />
      <HiringToolsSection theme={theme} />
      <CoursesSection theme={theme} />
      <SkillsTabs theme={theme} />
      <FaqSection theme={theme} />
      <Footer theme={theme} />
      <ScrollToTop />
    </div>
  );
};

export default LandingPage;
